import React, { useEffect, useState, useContext } from "react";
import { useHistory, withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Table,
  Progress,
  Select,
  message,
  Button,
  Divider,
  Tooltip,
  Icon,
  Popconfirm,
  DatePicker,
  Spin,
  Form,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
import Text from "antd/lib/typography/Text";
import "./index.less";
import { platformApi } from "../../api";
import { ContextAPI } from "../../ContextAPI";
import Chart from "react-apexcharts";
import VehicleName from "../VehicleName";
import moment from "moment";
import JobOrderModal from "../TransactionMasters/JobOrder/JobOrderModal";
import { useBranch } from "../../ContextAPI/branch";
const ServiceDashboard = (props) => {
  const { history } = props;
  const { loginCredintials } = useContext(ContextAPI);
  console.log("log:", loginCredintials);

  const [spinning, setSpinning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [jobView, setJobView] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [timeline, setTimeline] = useState("month");
  const [editable, setEditable] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [activeJobsData, setActiveJobsData] = useState([]);
  const [initialData, setInitialData] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [jobData, setJobData] = useState([]);
  const [jobDetail, setJobDetail] = useState(null);
  const [jobEditable, setJobEditable] = useState(false);
  const [showDate, setShowDate] = useState([]);

  const { selectBranch } = useBranch();

  const serviceType = [
    { key: 1, title: "Free" },
    { key: 2, title: "Engine Overhaul" },
    { key: 3, title: "Paid (UW)" },
    { key: 4, title: "Paid (AW)" },
    { key: 5, title: "AMC" },
    { key: 6, title: "Accidental" },
    { key: 7, title: "Minor" },
  ];
  const [mechanics, setMechanics] = useState(0);
  const [count, setCount] = useState({
    totalJobsCount: 0,
    totalPaidServiceCount: 0,
    vehicleReceivedCount: 0,
    EstimationCount: 0,
    MechanicAllocationCount: 0,
    WIPCount: 0,
    finalInspectionCount: 0,
    ReadyforDeliveryCount: 0,
    deliveredCount: 0,
    freeServiceCount: 0,
    paidAWServiceCount: 0,
    paidUWServiceCount: 0,
    engineOverhaulCount: 0,
    amcCount: 0,
    minorCount: 0,
    accidentialCount: 0,
    upComingJobsCount: 0,
    upComingFreeJobsCount: 0,
    upComingPaidJobsCount: 0,
    missedOppurturnitiesCount: 0,
    labourCharge: 0,
  });
  const [pieChartSeries, setPieChartSeries] = useState([]);
  const [pieChartOptions, setPieChartOptions] = useState({
    chart: {
      width: 320,
      type: "pie",
    },
    labels: [],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 100,
          },
        },
      },
    ],
  });
  const [serviceNoSeries, setServiceNoSeries] = useState([
    {
      name: "No.of Services",
      data: [
        {
          x: "",
          y: "",
        },
      ],
    },
  ]);

  const serviceNoOptions = {
    chart: {
      id: "apexchart-example",
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    title: {
      text: "",
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        "Free",
        "Engine Overhaul",
        "Paid (UW)",
        "Paid (AW)",
        "AMC",
        "Accidental",
        "Minor",
        "PDI",
      ],
      title: {
        text: "Service Type",
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#6c7b8a",
        },
        offsetY: -10,
      },
      labels: {
        rotate: -30,
        style: {
          colors: [
            "#33b2df",
            "#f48024",
            "#d4526e",
            "#13d8aa",
            "#A5978B",
            "#2b908f",
            "#f9a3a4",
            "#90ee7e",
            "#546E7A",
          ],
          fontSize: "11px",
        },
      },
    },
    yaxis: {
      title: {
        text: "Service Type Count",
        rotate: -90,
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#6c7b8a",
        },
      },
      labels: {
        style: {
          fontSize: "11px",
          colors: ["#6c7b8a"],
        },
      },
    },
    colors: [
      "#33b2df",
      "#f48024",
      "#d4526e",
      "#13d8aa",
      "#A5978B",
      "#2b908f",
      "#f9a3a4",
      "#90ee7e",
      "#546E7A",
    ],
    plotOptions: {
      bar: {
        distributed: true,
        borderRadius: 4,
        columnWidth: "75%",
        dataLabels: {
          position: "center",
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: { enabled: false },
    },
  };

  const [jobCodeSeries, setJobCodeSeries] = useState([
    {
      name: "JobCodes",
      data: [
        {
          x: "",
          y: "",
        },
      ],
    },
  ]);

  const jobCodeOptions = {
    chart: {
      id: "jobcode-bar-chart",
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    title: {
      text: "Labour by Job Code",
      align: "center",
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#3d4b5e",
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "category",
      categories: [],
      title: {
        text: "Job Code",
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#6c7b8a",
        },
        offsetY: 4,
      },
      labels: {
        rotate: -30,
        style: {
          colors: [
            "#33b2df",
            "#f48024",
            "#d4526e",
            "#13d8aa",
            "#A5978B",
            "#2b908f",
            "#f9a3a4",
            "#90ee7e",
            "#f4a261",
            "#2ec4b6",
            "#a0a0a0",
          ],
          fontSize: "11px",
        },
      },
    },
    yaxis: {
      title: {
        text: "Labour Amount (₹)",
        rotate: -90,
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#6c7b8a",
        },
      },
      labels: {
        formatter: (val) =>
          "₹ " +
          parseFloat(val || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
        style: {
          fontSize: "11px",
          colors: ["#6c7b8a"],
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) =>
        "₹ " +
        parseFloat(val || 0).toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: { enabled: false },
    },
    tooltip: {
      y: {
        formatter: (val) =>
          "₹ " +
          parseFloat(val || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
      },
    },
    colors: [
      "#33b2df",
      "#f48024",
      "#d4526e",
      "#13d8aa",
      "#A5978B",
      "#2b908f",
      "#f9a3a4",
      "#90ee7e",
      "#f4a261",
      "#2ec4b6",
      "#a0a0a0",
    ],
    plotOptions: {
      bar: {
        distributed: true,
        borderRadius: 4,
        dataLabels: {
          position: "center",
        },
      },
    },
  };

  useEffect(() => {
    if (initialData) {
      setInitialData(false);
    }
    getData(timeline, selectedEmployee);
  }, [timeline, selectedEmployee, fromDate, toDate, initialData, selectBranch]);

  const isMechanic = loginCredintials?.role === "Mechanic";

  useEffect(() => {
    // If the logged-in user is a Mechanic, restrict the employee list and
    // pre-selected employees to only themselves — no other mechanic's data.
    if (isMechanic) {
      const selfUser = {
        id: loginCredintials.employeeId,
        profile: { employeeName: loginCredintials.name || loginCredintials.employeeId }
      };
      setEmployee([selfUser]);
      setSelectedEmployee([loginCredintials.employeeId]);
      return;
    }

    platformApi.get("/api/user").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let tempUser = data.data.users.filter((item) => {
          return item.profile && item.profile?.department?.role === "Mechanic";
        });

        setEmployee(tempUser);
        setSelectedEmployee(tempUser.map((user) => user.id));
      }
    });
  }, []);

  const getData = (timeline, employee) => {
    setSpinning(true);
    // For Mechanic role: always scope the API query to only the logged-in mechanic.
    const effectiveEmployee = isMechanic
      ? [loginCredintials.employeeId]
      : employee;

    platformApi
      .post("/api/jobOrder/dashboard", {
        timeline,
        from: fromDate,
        to: toDate,
        employee: effectiveEmployee,
        current: loginCredintials.employeeId,
        branch: Array.isArray(selectBranch) ? selectBranch.map((b) => b.id) : []
      })
      .then((res) => {
        if (res.data.code === 200) {
          setCount(res.data.response.data);
          // Backend now filters jobOrders by the selected mechanic(s) — use directly.
          setActiveJobsData(res.data.response.data.jobOrders);

          //Service No Bar Graph
          const data = res.data.response.data;
          setServiceNoSeries([
            {
              data: [
                {
                  x: "Free",
                  y: data.freeServiceCount,
                },
                {
                  x: "Engine Overhaul",
                  y: data.engineOverhaulCount,
                },
                {
                  x: "Paid (UW)",
                  y: data.paidUWServiceCount,
                },
                {
                  x: "Paid (AW)",
                  y: data.paidAWServiceCount,
                },
                {
                  x: "AMC",
                  y: data.amcCount,
                },
                {
                  x: "Accidential",
                  y: data.accidentialCount,
                },
                {
                  x: "Minor",
                  y: data.minorCount,
                },
                {
                  x: "PDI",
                  y: data.pdiCount,
                },
              ],
            },
          ]);

          //PieChart
          const labour = res.data.response.data.labourData;
          for (let itr = 0; itr < labour.length; itr++) {
            const jobOrder = labour[itr];
            var count = 0;
            for (let index = 0; index < labour.length;) {
              const element = labour[index];
              if (index <= itr) {
                index++;
                continue;
              }
              if (element.mechanic.id === jobOrder.mechanic.id) {
                count = count + element.total;
                labour.splice(index, 1);
              } else {
                index++;
              }
            }
            jobOrder.Overall = jobOrder.total + count;
          }
          let labourtotal = [],
            mechanic = [];
          labour.map(
            (item) => (
              labourtotal.push(item.Overall),
              mechanic.push(item.mechanic?.profile?.employeeName)
            )
          );

          setMechanics(mechanic.length);
          setPieChartSeries(labourtotal);
          setPieChartOptions({
            labels: mechanic,
            legend: {
              show: false,
            },
          });

          // console.log(res.data.response.data.jobCodes)
          //JobCodes Bar Graph — group by jobCode, sum amounts, sort desc, top 10
          const rawJobCodes = res.data.response.data.jobCodes;

          // Step 1: Group by jobCode and sum totalAmt using a Map
          const jobCodeMap = new Map();
          rawJobCodes.forEach((item) => {
            const code = item.jobCode;
            const amt = parseFloat(item.count) || 0;
            if (jobCodeMap.has(code)) {
              jobCodeMap.set(code, jobCodeMap.get(code) + amt);
            } else {
              jobCodeMap.set(code, amt);
            }
          });

          // Step 2: Convert to array and sort descending by totalAmt
          const sortedJobCodes = Array.from(jobCodeMap, ([jobCode, totalAmt]) => ({
            jobCode,
            totalAmt,
          })).sort((a, b) => b.totalAmt - a.totalAmt);

          // Step 3: Take exactly top 10
          const top10 = sortedJobCodes.slice(0, 10);

          // Step 4: Build series data { x: jobCode, y: totalAmt }
          const jobCodeSeriesData = top10.map((item) => ({
            x: item.jobCode,
            y: item.totalAmt,
          }));

          setJobCodeSeries([
            {
              name: "Labour Amount (₹)",
              data: jobCodeSeriesData,
            },
          ]);

          setSpinning(false);
        } else if (res.data.code === 500) {
          message.error("Unable to fetch data", 2);
        }
      });
  };

  const handleDateChange = async (date, dateString) => {
    await setFromDate(dateString[0]);
    await setToDate(dateString[1]);
    //  getData(timeline, selectedEmployee)
  };
  const filterMethod = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const activeJobsColumn = [
    {
      title: "Customer Details",
      dataIndex: "customer",
      key: "customer",
      render: (record, data) => (
        <span>
          {record ? record.name : data.customerName} -{" "}
          {record ? record.contacts[0].phone : data.customerPhone}
        </span>
      ),
    },
    {
      title: "Model",
      dataIndex: "vehicle",
      key: "vehicleModal",
      width: 260,
      render: (record) => (
        <VehicleName value={record?.vehicle} />
      ),
    },
    {
      title: "Color",
      dataIndex: "vehicle",
      key: "vehicleColor",
      render: (record, data) => (
        <span>
          {record?.color?.code} - {record?.color?.color}
        </span>
      ),
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Job ID",
      dataIndex: "jobNo",
      key: "jobNo",
      render: (record) => <span className="linkylink">{record}</span>,
    },
    {
      title: "Mechanic",
      dataIndex: "mechanic",
      key: "mechanic",
      render: (record) => (
        <span>
          {record?.profile?.employeeName} - {record?.profile?.employeeId}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "jobStatus",
      key: "jobStatus",
      render: (record) => <span>{record}</span>,
    },
  ];
  const openJobOrder = (edit = false, record = null) => {
    setJobEditable(edit);
    if (record) {
      let jobId = record.id;
      getJobOrder(jobId).then(() => setJobView(true));
    } else {
      setJobView(true);
    }
  };
  const getJobOrder = (id) => {
    return new Promise(async (resolve, reject) => {
      platformApi.get("/api/jobOrder/" + id).then((res) => {
        const {
          data: {
            response: { data },
          },
        } = res;
        setJobDetail(data);
        resolve(data);
      });
    });
  };

  // --------------------------------------------------

  useEffect(() => {
    const { fromDate, toDate } = DateShow(timeline);

    if (timeline === "date") {
      setShowDate([]);
      setFromDate();
      setToDate();
    } else {
      let arr = [];
      arr.push(fromDate);
      arr.push(toDate);
      setShowDate(arr);
    }
  }, [timeline]);

  const handleTimeline = (e) => {
    if (e !== "date") {
      const { fromDate, toDate } = DateShow(e);
      let arr = [];
      arr.push(fromDate);
      arr.push(toDate);
      setShowDate(arr);
    } else if (e === "date") {
      setShowDate([]);
      setFromDate(null);
      setToDate(null);
    }
    setTimeline(e);
  };

  const DateShow = (timeline, from, to) => {
    let toDate;
    let fromDate;
    let months;

    switch (timeline) {
      case "today":
        fromDate = moment(new Date()).startOf("day");
        toDate = moment(new Date()).endOf("day");
        months = [moment(new Date()).format("MMM")];
        break;
      case "week":
        fromDate = moment(new Date()).startOf("week");
        toDate = moment(new Date()).endOf("week");
        months = [moment(new Date()).format("MMM")];
        break;
      case "month":
        fromDate = moment(new Date()).startOf("month");
        toDate = moment(new Date()).endOf("month");
        months = [moment(new Date()).format("MMM")];
        break;
      case "quarterly":
        fromDate = moment(new Date()).startOf("quarter");
        toDate = moment(new Date()).endOf("quarter");
        months = [
          fromDate.format("MMM"),
          moment(fromDate).add(1, "months").format("MMM"),
          moment(toDate).format("MMM"),
        ];
        break;
      case "halfyearly":
        var tempDate;
        var tempEnd;
        if (
          moment(new Date()).startOf("month").format("MM") > 3 &&
          moment(new Date()).startOf("month").format("MM") < 7
        ) {
          tempDate = moment(new Date()).subtract(3, "M").startOf("quarter");
        } else if (
          moment(new Date()).startOf("month").format("MM") > 9 &&
          moment(new Date()).startOf("month").format("MM") <= 12
        ) {
          tempDate = moment(new Date()).subtract(3, "M").startOf("quarter");
        } else {
          tempDate = moment(new Date()).startOf("quarter");
        }
        if (
          moment(new Date()).startOf("month").format("MM") >= 1 &&
          moment(new Date()).startOf("month").format("MM") < 4
        ) {
          tempEnd = moment(new Date()).add(3, "M").endOf("quarter");
        } else if (
          moment(new Date()).startOf("month").format("MM") > 6 &&
          moment(new Date()).startOf("month").format("MM") <= 9
        ) {
          tempEnd = moment(new Date()).add(3, "M").endOf("quarter");
        } else {
          tempEnd = moment(new Date()).endOf("quarter");
        }
        fromDate = tempDate;
        toDate = tempEnd;
        months = [
          fromDate.format("MMM"),
          moment(fromDate).add(1, "months").format("MMM"),
          moment(fromDate).add(2, "months").format("MMM"),
          moment(fromDate).add(3, "months").format("MMM"),
          moment(fromDate).add(4, "months").format("MMM"),
          moment(toDate).format("MMM"),
        ];
        break;
      case "year":
        fromDate = moment(new Date()).startOf("year");
        toDate = moment(new Date()).endOf("year");
        months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        break;
      case "date":
        fromDate = moment(from, "DD-MM-YYYY").startOf("day");
        toDate = moment(to, "DD-MM-YYYY").endOf("day");
        var difference = toDate.diff(fromDate, "months");
        if (difference == 0) {
          months = [moment(fromDate).format("MMM")];
        } else if (difference == 1) {
          months = [
            moment(fromDate).format("MMM"),
            moment(toDate).format("MMM"),
          ];
        } else {
          months = [moment(fromDate).format("MMM")];
          for (let i = 0; i < difference; i = i + 1) {
            months.push(moment(fromDate).add(i, "months").format("MMM"));
          }
          months.push(moment(toDate).format("MMM"));
        }
        break;
      default:
        fromDate = moment(new Date()).startOf("day");
        toDate = moment(new Date()).endOf("day");
        months = [moment(new Date()).format("MMM")];
    }

    return { fromDate, toDate, months };
  };

  return (
    <>
      <Spin spinning={spinning}>
        {/* Dashboard Header & Filters */}
        <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: "15px", background: "white", padding: "12px 20px", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <Col>
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "bold", color: "#3d4b5e" }}>
              Service Dashboard
            </h2>
          </Col>
          <Col style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {/* Mechanic filter: hidden for Mechanic-role users (they can only see their own data) */}
            {!isMechanic && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontWeight: "bold", color: "#475569" }}>Mechanic:</span>
                <Select
                  style={{ width: 250 }}
                  placeholder="Employee"
                  mode="multiple"
                  showSearch
                  value={selectedEmployee}
                  filterOption={filterMethod}
                  onChange={(e) => {
                    setSelectedEmployee(e);
                  }}
                >
                  {employee.map((data) => (
                    <Select.Option key={data.id}>
                      {data && data?.profile && data.profile?.employeeName}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontWeight: "bold", color: "#475569" }}>Timeline:</span>
              <Select
                style={{ width: 160 }}
                value={timeline}
                onChange={(e) => {
                  setTimeline(e);
                  handleTimeline(e);
                }}
                placeholder="Timeline"
              >
                <Select.Option value="today">Today</Select.Option>
                <Select.Option value="week">This Week</Select.Option>
                <Select.Option value="month">This Month</Select.Option>
                <Select.Option value="quarterly">This Quarter</Select.Option>
                <Select.Option value="halfyearly">Half-Yearly</Select.Option>
                <Select.Option value="year">This Year</Select.Option>
                <Select.Option value="date">Select a Date Range</Select.Option>
              </Select>
            </div>

            {timeline === "date" ? (
              <RangePicker
                onChange={handleDateChange}
                format={"DD/MM/YYYY"}
                style={{ width: 230 }}
              />
            ) : (
              <RangePicker
                disabled={true}
                value={showDate}
                format={"DD/MM/YYYY"}
                style={{ width: 230 }}
              />
            )}
          </Col>
        </Row>

        <div style={{ background: "#f4f7fb" }}>
          <Row gutter={16} style={{ marginBottom: "10px" }}>
            <Col span={7}>
              <Text style={{ fontWeight: "bold" }}>Team Statistics</Text>
            </Col>
          </Row>
          <Row
            type="flex"
            style={{ border: "1px solid black" }}
          >
            <Col span={9} style={{ padding: "10px 15px 10px 10px", borderRight: "1px solid #e8e8e8" }}>
              <Chart
                options={serviceNoOptions}
                series={serviceNoSeries}
                type="bar"
                width="100%"
                height={370}
              />
            </Col>
            <Col span={15} style={{ marginTop: "25px", paddingLeft: "25px", paddingRight: "15px" }}>
              <Row gutter={[16, 20]}>
                {/* Row 1 */}
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Labour Charge
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      ₹ {parseFloat(count.labourCharge || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "2px 2px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Vehicle Received
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.vehicleReceivedCount}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "2px 2px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Estimation Gen/App.
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.EstimationCount}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 10px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        color: "#a8afb3",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      Mechanic Allocated
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.MechanicAllocationCount}
                    </p>
                  </div>
                </Col>

                {/* Row 2 */}
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "2px 2px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Work In Progress
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.WIPCount}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "2px 2px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Final Inspection
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.finalInspectionCount}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "2px 2px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Ready for Delivery
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.ReadyforDeliveryCount}
                    </p>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      height: "140px",
                      background: "white",
                      padding: "10px 10px 0px 10px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Delivered Jobs
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.deliveredCount}
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <br />
        <div style={{ background: "#f4f7fb", marginTop: "1%" }}>
          <Row gutter={16} style={{ marginBottom: "10px" }}>
            <Col span={7}>
              <Text style={{ fontWeight: "bold" }}>Labour by Job code</Text>
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            style={{ border: "1px solid black" }}
          >
            <Col span={12}>
              <Chart
                options={jobCodeOptions}
                series={jobCodeSeries}
                type="bar"
                width={540}
                height={380}
              />
            </Col>
            <Col span={12} style={{ marginTop: "25px" }}>
              <Col span={24}>
                <Row
                  style={{
                    marginTop: "10px",
                    marginLeft: "-8.5px",
                    marginRight: "4%",
                  }}
                >
                  <Col
                    span={10}
                    style={{
                      background: "white",
                      marginLeft: "15px",
                      marginRight: "5px",
                      padding: "15px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        color: "#a8afb3",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      Paid Service (%)
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "10px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count?.totalPaidServiceCount && count?.totalJobsCount ? (
                        (count.totalPaidServiceCount / count.totalJobsCount) *
                        100
                      ).toFixed(2) : "0"}
                    </p>
                  </Col>
                  <Col
                    span={10}
                    style={{
                      background: "white",
                      marginLeft: "15px",
                      marginRight: "5px",
                      padding: "15px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Free Service(%)
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "4px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count?.freeServiceCount && count?.totalJobsCount ? (
                        (count.freeServiceCount / count.totalJobsCount) *
                        100
                      ).toFixed(2) : "0"}
                    </p>
                  </Col>
                </Row>
                <Row
                  style={{
                    backgroundColor: "white",
                    textAlign: "center",
                    marginTop: "30px",
                    marginLeft: "-8px",
                    marginRight: "4%",
                    paddingTop: "10px",
                  }}
                >
                  <Text
                    style={{
                      color: "#a8afb3",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    Upcoming Service
                  </Text>{" "}
                </Row>
                <Row
                  style={{
                    marginTop: "0px",
                    marginLeft: "-8.5px",
                    marginRight: "4%",
                  }}
                >
                  <Col
                    span={8}
                    style={{
                      background: "white",
                      padding: "5px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Total
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "4px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.upComingJobsCount}
                    </p>
                  </Col>
                  <Col
                    span={8}
                    style={{
                      background: "white",
                      padding: "5px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                    onClick={() => {
                      history.push({
                        pathname: "/autoadmin/service_reminder",
                        state: {
                          status: "PAID",
                        },
                      });
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Paid
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "4px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.upComingPaidJobsCount}
                    </p>
                  </Col>
                  <Col
                    span={8}
                    style={{
                      background: "white",
                      padding: "5px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                    onClick={() => {
                      history.push({
                        pathname: "/autoadmin/service_reminder",
                        state: {
                          status: "FREE",
                        },
                      });
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Free
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "4px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.upComingFreeJobsCount}
                    </p>
                  </Col>
                </Row>
                <Row
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                    marginTop: "30px",
                    padding: "15px",
                    marginLeft: "20%",
                  }}
                >
                  <Col
                    span={12}
                    style={{
                      background: "white",
                      padding: "5px 15px 0px 15px",
                      textAlign: "center",
                      boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.13)",
                    }}
                    onClick={() => {
                      history.push({
                        pathname: "/autoadmin/service_reminder",
                        state: {
                          status: "MISSED",
                        },
                      });
                    }}
                  >
                    <Text
                      style={{
                        padding: "5px 4px ",
                        color: "#a8afb3",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "12px",
                      }}
                    >
                      Missed Oppurturnities
                    </Text>
                    <p
                      style={{
                        fontSize: "26px",
                        paddingTop: "4px",
                        color: "#6c7b8a",
                      }}
                    >
                      {count.missedOppurturnitiesCount}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
        </div>
        <Row style={{ marginTop: "25px" }}>
          <Col span={24}>
            <Text style={{ padding: "10px 0px 20px 10px", fontWeight: "bold" }}>
              Active Jobs [{activeJobsData.length}]
            </Text>
            <Table
              // size="small"
              columns={activeJobsColumn}
              dataSource={activeJobsData}
              rowKey="id"
              className="todaysTaskTable"
              pagination={{
                pageSize: 6,
                defaultCurrent: 1,
                showQuickJumper: true,
              }}
              onRow={(record, index) => {
                return {
                  onClick: () => {
                    openJobOrder(false, record);
                  },
                };
              }}
              // title={() => 'Todays Tasks'}
              style={{ cursor: "pointer", margin: "20px 0px 0px 0px" }}
            />
          </Col>
        </Row>
      </Spin>
      <JobOrderModal
        open={jobView}
        data={jobDetail}
        emitData={(data) => addData(data)}
        editable={editable}
        setEditFlag={setEditable}
        changed={change}
        setChange={setChange}
        loading={loading}
        setLoading={setLoading}
        close={() => {
          setJobView(false);
          setJobDetail(null);
        }}
      />{" "}
    </>
  );
};

export default withRouter(ServiceDashboard);
